import { TextType } from "../type/TextType";
import { ComponentF, createElement } from "../ui";
import { Bar } from "./Bar";
export const LabeledBar: ComponentF<{
  current: number;
  max?: number;
  title: string;
  fillColor: string;
}> = (C, props = { current: 0, title: "", fillColor: "#FFFFFF" }) => {
  return [
    createElement(
      TextType,
      { x: 0, y: 0, w: C.bounds.w, h: 1 },
      { title: props.title }
    ),
    createElement(Bar, { x: 0, y: 1, w: C.bounds.w, h: 1 }, props),
  ];
};
